import { useState }                 from 'react'
import styled                       from 'styled-components/macro'
import { Swiper, SwiperSlide }      from 'swiper/react'
import { Pagination, Keyboard }     from 'swiper'
import { SwiperStyle, SliderStyle } from './MaximizedGallery.Swiper.style'
import { SwiperNav }                from './MaximizedGallery.Navigation'
import { CatchSlide }               from './MaximizedGallery.catch'
import { ImgWrapper } from 'components/ImgContainer/ImgWrapper'

export const Slider = ({initial, images}) => {

  const [ activeIndex, setActiveIndex ] = useState(0)

  const swiper = {
    modules       : [Keyboard], //Pagination, add in array for pagination
    slidesPerView : 1,
    spaceBetween  : 20,
    initialSlide  : initial ?? 0,
    pagination    : { dynamicBullets: true },
    keyboard      : { enabled: true },
    onSlideChange : e => { setActiveIndex( e.activeIndex ) }
  }
  
  return (
    <StyleInjection>
      <Swiper {...swiper}>
        { images?.length > 1 && <SwiperNav activeIndex={activeIndex} {...{images}}/>}
        { 
          images?.map((img, i) => (
            <SwiperSlide style={{ transform: "unset", backfaceVisibility: "unset" ,}} key={i}>
              <ImgWrapper img={img.url} alt=''
                imgStyle={{ display : "block",
                  width        : "100%",
                  height       : "100%",
                  objectFit    : "contain",
                  borderRadius : "6px" }} 
                  />
          {/* <img
              src={img.url}
              alt=""
              style={{
                display      : "block",
                width        : "100%",
                height       : "auto",
                maxHeight    : "calc(90vh - 120px)",
                objectFit    : "contain",
                borderRadius : "6px",
              }}
            /> */}
              {/* <Img src={img.url} alt='' style={{ borderRadius: '6px' }}/> */}
              <CatchSlide/>
            </SwiperSlide>
          ))
        }
      </Swiper>
    </StyleInjection>
  )
}


const StyleInjection = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;   /* 👈 was: height: auto */
  ${SwiperStyle}
  ${SliderStyle}
`